import React,{useContext,useState} from 'react';
import { Offcanvas, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../css/MobileMenuOffCanvas.css'
import {
  faHome,
  faInfoCircle,
  faPhone,
  faGavel,
  faShoppingBag,
  faHeart,
  faUser,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from '../context/AuthContext';
import { BedIcon, Box, Calendar, Contact, Cookie, Hammer, House, InfoIcon, MessageSquareMore, Rotate3D, RotateCcw, ShoppingBag, ShoppingBasket, Truck, User, UserCircle } from 'lucide-react';
import Feedback from "../components/Feedback"; // import your feedback component

const MobileMenu = ({ show, handleClose, language }) => {
    const { currentUser, logout } = useContext(AuthContext);
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const handleFeedbackOpen = () => {
      // Assuming handleClose is closing menu etc
      handleClose(); 
      setFeedbackVisible(true);
    };
    const handleFeedbackClose = () => setFeedbackVisible(false);

  return (
    <>
    <Offcanvas
      className="offcanvas-header-menu"
      show={show}
      onHide={handleClose}
      placement="start"
      backdrop
     
    >
      <Offcanvas.Header closeButton className="offcanvas-header-custom">
        <Offcanvas.Title>
          <span style={{color:'#54b435'}} >
           Kabili Holidays
          </span>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="mobile-menu-body">
      <Nav.Link as={Link} to="/account" onClick={handleClose} className="menu-text-mob">
        <div className="user-info mb-4 text-center"> 
            <User size={50}  className="me-2" />
          <div className="username">Hello,{currentUser?.name || 'User'}!</div>
         
        </div>
        </Nav.Link>
        
        <Nav className="flex-column">
        <Nav.Link as={Link} to="/account" onClick={handleClose} className="menu-text-mob">
            <User size={20}  className="me-2 cus-color" />  {currentUser?"My account":"Login"}
          </Nav.Link>
          <Nav.Link as={Link} to="/" onClick={handleClose} className="menu-text-mob">
            <House size={20}  className="me-2 cus-color" /> Home
          </Nav.Link>
          <Nav.Link as={Link} to="/about" onClick={handleClose} className="menu-text-mob">
            <InfoIcon size={20}  className="me-2 cus-color" /> About
          </Nav.Link>
          <Nav.Link as={Link} to="/contact" onClick={handleClose} className="menu-text-mob">
            <Contact size={20}  className="me-2 cus-color" /> Contact
          </Nav.Link>
          <Nav.Link as={Link} to="/account"  state={{ tab: 'Bookings' }} onClick={handleClose} className="menu-text-mob">
            <BedIcon size={20}  className="me-2 cus-color" /> My Bookings
          </Nav.Link>
        
          <Nav.Link  onClick={handleFeedbackOpen}  className="menu-text-mob">
            <MessageSquareMore size={20}  className="me-2 cus-color" /> Feed back
          </Nav.Link>
          <Nav.Link as={Link} to="/termsandcondition" onClick={handleClose} className="menu-text-mob">
            <Hammer size={20}  className="me-2 cus-color" /> Terms & Conditions
          </Nav.Link>
          <Nav.Link as={Link} to="/privacy-policy" onClick={handleClose} className="menu-text-mob">
            <Cookie size={20}  className="me-2 cus-color" /> Privacy policy
          </Nav.Link>
          <Nav.Link as={Link} to="/cancellation-policy" onClick={handleClose} className="menu-text-mob">
            <RotateCcw size={20}  className="me-2 cus-color" /> Cancellation policy
          </Nav.Link>
       

         
        </Nav>
      </Offcanvas.Body>
    </Offcanvas>
      <Feedback show={feedbackVisible} onClose={handleFeedbackClose} />
      </>
  );
};

export default MobileMenu;
